module.exports = __webpack_public_path__ + "x_popup.svg?16242343f95a4f575ce99ef23ee848a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x_popup.svg
// module id = 949
// module chunks = 0